import {oneSwotItemURL} from "../../../services/api";
import api from "../../../services/instanceapi";
import {DELETE_ONE_SWOT_ITEM, LOADING_PATCH_SWOT_ITEM, PATCH_ONE_SWOT_ITEM, SWOT_ITEM_FAIL} from "./actionTypes";


export const patchOneSwotItem = (id, item) => async (dispatch) => {
    dispatch({
        type: LOADING_PATCH_SWOT_ITEM,
    })
    try {
        const updatedItem = await api.patch(oneSwotItemURL(id), item)
        const data = updatedItem.data
        dispatch({
            type: PATCH_ONE_SWOT_ITEM,
            payload: {
                id: data.id,
                type: data.type,
                content: data.content,
            }
        })
    } catch (e) {
        dispatch({
            type: SWOT_ITEM_FAIL
        })
    }

}

export const deleteOneSwotItem = (id) => async (dispatch) => {
    try {
        await api.delete(oneSwotItemURL(id))
        dispatch({
            type: DELETE_ONE_SWOT_ITEM,
            payload: {
                status: 204,
                message: "Deleted",
            }
        })
    } catch (e) {
        dispatch({
            type: SWOT_ITEM_FAIL
        })
    }

}